import React from 'react';

import HomeBanner from './HomeBanner';
import HomeRecordLabel from './HomeRecordLabel';
import HomeApparel from './HomeApparel';
import HomeLiveExperience from './HomeLiveExperience';
import HomeFooter from './HomeFooter';
import ScrollStickyNav from '../nav/ScrollStickyNav';

export const Home = () => {
  return (
    <div className='mhc_home'>
      <ScrollStickyNav />
      <HomeBanner />
      <HomeRecordLabel />
      <HomeLiveExperience />
      <HomeApparel />
      <HomeFooter />
    </div>
  );
};

export default Home;
